import { BasicButton } from "../buttons/BasicButton";
import { useState } from "react";
import { useFunctionalInterfacesStore } from "@/frontend/store/FunctionalInterfaceStore";
import { I18n } from "@/i18n/I18n";
import { useProcedureInstanceStore } from "@/frontend/store/ProcedureInstanceStore";
import { SelectFunctionalInterfaceModal } from "./SelectFunctionalInterfaceModal";

export const AddFunctionalInterfaceButton = () => {
  const functionalInterfaces = useFunctionalInterfacesStore((state) => state.functionalInterfaces);
  const versionsInProcedure = useFunctionalInterfacesStore((state) => state.functionalInterfaceVersions);
  const procedure = useProcedureInstanceStore((state) => state.procedureInstance);
  const addLatestVersionToProcedure = useFunctionalInterfacesStore((state) => state.addLatestVersionToProcedure);

  const [showModal, setShowModal] = useState(false);

  const filteredFunctionalInterfaces = functionalInterfaces.filter((functionalInterface) => !versionsInProcedure.some((version) => version.functionalInterfaceId === functionalInterface.id));

  if(!procedure) return null;

  return (
    <>
      <BasicButton className='btn btn-sm btn-primary' onClick={() => setShowModal(true)} label={I18n.get('addFunctionalInterface')} />
      {showModal && <SelectFunctionalInterfaceModal 
        setShowModal={setShowModal} 
        functionalInterfaces={filteredFunctionalInterfaces} 
        onSubmit={(options: { functionalInterfaceId: string }) => void addLatestVersionToProcedure(options.functionalInterfaceId, procedure.id)} 
      />}
    </>

  );
};